//
//
//
//
export default {
  name: 'cloudImage',
  data: function data() {
    return {
      url: ''
    };
  },
  props: {
    width: {
      default: 600
    },
    height: {
      default: 600
    }
  },
  created: function created() {
    this.url = location.origin + '/cloudImage/index.html';
  }
};